var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vx-card',[_c('vs-tabs',{model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[(_vm.userRoot)?_c('vs-tab',{attrs:{"label":"Editoriales"}},[_c('editoriales')],1):_vm._e(),(_vm.userRoot)?_c('vs-tab',{attrs:{"label":"Cargos Autoridades"}},[_c('autoridades_institucion')],1):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }